import { render, staticRenderFns } from "./SetHolidays.vue?vue&type=template&id=34c04a78&scoped=true&"
import script from "./SetHolidays.vue?vue&type=script&lang=js&"
export * from "./SetHolidays.vue?vue&type=script&lang=js&"
import style0 from "./SetHolidays.vue?vue&type=style&index=0&id=34c04a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c04a78",
  null
  
)

export default component.exports